export const getTripButtonState = (currentTrip: CurrentTrip, handoverStatus: boolean, isLoading: boolean = false) => {
  if (isLoading) {
    return {
      type: 'loading' as const,
      label: 'Loading...',
      color: 'default' as const,
      backgroundColor: '#E0E0E0',
      disabled: true
    };
  }

  if (!currentTrip || currentTrip.errors === 'Trip not found' || currentTrip.start_time === null) {
    return {
      type: 'start' as const,
      label: 'Start Trip',
      color: 'success',
      backgroundColor: '#1EB72A',
      disabled: false
    };
  }

  if (currentTrip.status === 'trip started' && !handoverStatus) {
    return {
      type: 'end' as const,
      label: 'End Trip',
      color: 'error',
      backgroundColor: '#FF4D4D',
      disabled: false
    };
  }

  if (currentTrip.status === 'trip started' && handoverStatus) {
    return {
      type: 'handover' as const,
      label: 'Handover',
      color: 'warning',
      backgroundColor: '#DC8A17',
      disabled: false
    };
  }

  if (currentTrip.status === 'handover' && handoverStatus) {
    return {
      type: 'disabledHandover' as const,
      label: 'Handover',
      color: 'default',
      backgroundColor: '#E0E0E0',
      disabled: true
    };
  }

  return {
    type: 'start' as const,
    label: 'Start Trip',
    color: 'success',
    backgroundColor: '#1EB72A',
    disabled: false
  };
};